import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postProposalStatus } from 'api/resources/proposals';
import { ECacheKeys } from 'cache/CacheKeys';

export const usePostProposalsStatus = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: postProposalStatus,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [ECacheKeys.Overviews],
			});
		},
	});
};
